import './AntragPrint.css';
import { Stack } from '@efast_public/fjd-component-library';
import React, { forwardRef } from 'react';
import {
  NodeType,
  PresentationNode
} from '../../api/models/Case/PresentationModel';
import { AntragPageV2 } from './AntragPageV2';
import { CaseDetailsModel } from '../../api/models/Case/CaseDetailsModel';
import { CoverPage } from './CoverPage';

interface AntragPrintV2Props {
  data: Record<string, PresentationNode>;
  caseDetails: CaseDetailsModel;
  hideEmpty?: boolean;
}

export const AntragPrintV2 = forwardRef<HTMLDivElement, AntragPrintV2Props>(
  ({ data, caseDetails, hideEmpty }, ref) => {
    const entries = Object.entries(data);

    return (
      <div ref={ref}>
        <CoverPage caseDetails={caseDetails} />
        <Stack spacing="m" className="print-page__wizard-container">
          {entries.map(([key, node]) => (
            <AntragPageV2 key={key} node={node} hideEmpty={hideEmpty} />
          ))}
        </Stack>
      </div>
    );
  }
);
